import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import IconButton from '@mui/material/IconButton'
import { IoNotificationsSharp } from 'react-icons/io5'
import { FaMinimize } from 'react-icons/fa6'
import defaultTexts from '../../texts/texts'
import { setLatestAlertsExpanded } from '../../store/reducers/settingsSlice'
import CustomCard from '../_common/CustomCard'
import LatestNotificationItem from './LatestNotificationItem'

const LatestNotificationsWrapper = (props) => {
  const { bodyHeight, latestAlerts } = props
  const theme = useTheme()
  const dispatch = useDispatch()

  const latest_alerts_expanded = useSelector(state => state.settings.latest_alerts_expanded)

  const wrapperStyle = {
    background: theme.palette.aliceBlue,
    borderRadius: '50px 20px 20px 20px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  }

  const labelStyle = {
    height: '60px',
    background: theme.palette.greenSheen,
    color: 'white',
    fontSize: '20px',
    fontWeight: '500',
    borderRadius: '50px 0px',
    padding: '0px 40px',    
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const bodyStyle = {
    padding: '20px',
  }

  const flexBodyStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const noAlertsNotificationStyle = {
    fontSize: '24px',
    textAlign: 'center',
    padding: '20px 0px',
  }

  const expandIconStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '30px',
    background: theme.palette.greenSheen,
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const hideIconStyle = {
    marginRight: '10px',
  }

  const handleClickExpand = () => {
    dispatch(setLatestAlertsExpanded({ latest_alerts_expanded: true }))
  }

  const handleClickHide = () => {
    dispatch(setLatestAlertsExpanded({ latest_alerts_expanded: false }))
  }

  const getContent = () => {
    return (
      <>
        {
          latestAlerts.length > 0 ?
          <Box sx={{ padding: '0px 10px 20px 10px' }}>
            {
              latestAlerts.map((item, index) => (
                <LatestNotificationItem key={index} {...item} />
              ))
            }
          </Box> :
          <Box sx={noAlertsNotificationStyle}>{defaultTexts.noNotifications}</Box>
        }
      </>
    )
  }

  return (
    <>
      {
        latest_alerts_expanded ?
        <Box sx={wrapperStyle}>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <Box sx={labelStyle}>{defaultTexts.latestNotifications}</Box>
            <IconButton sx={hideIconStyle} onClick={handleClickHide}>
              <FaMinimize color={theme.palette.greenSheen} />
            </IconButton>
          </Stack>

          {
            bodyHeight ?
            <CustomCard
              sx={ latestAlerts.length > 0 ?
                {
                  ...bodyStyle,
                  height: bodyHeight ? `${bodyHeight}px` : 'auto', 
                } :
                {
                  ...bodyStyle,
                  ...flexBodyStyle,
                  height: bodyHeight ? `${bodyHeight}px` : 'auto', 
                }
              }
            >
              {getContent()}
            </CustomCard> :
            <>{getContent()}</>
          }      
        </Box> :
        <Box sx={expandIconStyle} onClick={handleClickExpand}>
          <IoNotificationsSharp size={36} />
        </Box>
      }
    </>
  )
}

export default LatestNotificationsWrapper